import { useMemo } from 'react'
import { PageLoader } from 'shared/ui/layout/PageLoader'
import { DashboardRowCollateral } from 'modules/pools/ui/DashboardRowCollateral'
import { DashboardEmptyCTA } from 'modules/pools/ui/DashboardEmptyCTA'

import { createRoute } from 'modules/router/utils/createRoute'
import * as links from 'modules/router/links'
import { useCollateralData } from 'modules/pools/hooks/useCollateralData'
import { PoolAsset } from 'modules/pools/constants/poolAssets'

import s from './RouteDashboardCollateral.module.scss'

function RouteDashboardCollateral() {
  const { data, isLoading, isValidating } = useCollateralData()

  const collateralData = useMemo(() => {
    if (!data) return []

    return Object.keys(data).map((asset: PoolAsset) => data[asset])
  }, [data])

  if (isLoading || isValidating) {
    return <PageLoader />
  }

  if (!collateralData.length) {
    return (
      <DashboardEmptyCTA
        link={links.borrow}
        fashion="purple"
        timeText="There is no"
        entityName="collateral"
        actionText="Borrow"
      />
    )
  }

  return (
    <>
      {collateralData.map(
        ({ asset, totalAmount, lockedAmount, availableAmount }) => (
          <DashboardRowCollateral
            key={asset}
            asset={asset}
            totalAmount={totalAmount}
            lockedAmount={lockedAmount}
            availableAmount={availableAmount}
            className={s.row}
          />
        ),
      )}
    </>
  )
}

export const routeDashboardCollateral = createRoute({
  component: RouteDashboardCollateral,
  checkConnect: true,
})
